"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionRoutePlanStopTransport = exports.RoutePlanStopUpdate = exports.RoutePlanStopCreateNested = exports.RoutePlanStopCreate = exports.RoutePlanStopQuery = exports.RoutePlanStopWithFullRoutePlanTransport = exports.RoutePlanStopTransport = exports.RoutePlanStop = exports.RoutePlanStopStatusTypeLabels = exports.RoutePlanStopStatusType = exports.RoutePlanStopStatusTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const AbstractRouteStop_1 = require("../common/AbstractRouteStop");
const OneOffPickupRequest_1 = require("../route-planning/OneOffPickupRequest");
const RoutePlanTemplateStop_1 = require("../route-planning/RoutePlanTemplateStop");
const ServicePeriod_1 = require("../subscriptions-and-billing/ServicePeriod");
const SubscriptionEquipment_1 = require("../subscriptions-and-billing/SubscriptionEquipment");
const ActualRouteBreadcrumb_1 = require("./ActualRouteBreadcrumb");
const DailyRoutePlan_1 = require("./DailyRoutePlan");
exports.RoutePlanStopStatusTypes = ['PENDING', 'IN_PROGRESS', 'COMPLETE', 'ISSUE'];
exports.RoutePlanStopStatusType = typebox_1.Type.Union(exports.RoutePlanStopStatusTypes.map((val) => typebox_1.Type.Literal(val)));
exports.RoutePlanStopStatusTypeLabels = {
    PENDING: {
        singular: 'Not started',
    },
    IN_PROGRESS: {
        singular: 'En route',
    },
    COMPLETE: {
        singular: 'Complete',
    },
    ISSUE: {
        singular: 'Issue',
    },
};
exports.RoutePlanStop = typebox_1.Type.Composite([
    AbstractRouteStop_1.AbstractRouteStop,
    typebox_1.Type.Object({
        oneOffPickupRequest: typebox_1.Type.Optional(OneOffPickupRequest_1.OneOffPickupRequest),
        templateStop: typebox_1.Type.Optional(RoutePlanTemplateStop_1.RoutePlanTemplateStop),
        routePlanID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        breadcrumb: typebox_1.Type.Optional(ActualRouteBreadcrumb_1.ActualRouteBreadcrumb),
        eventIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
        currentServicePeriod: typebox_1.Type.Optional(ServicePeriod_1.ServicePeriod),
        // Fields that come from the underlying schedule
        routeName: typebox_1.Type.Optional(typebox_1.Type.String()),
        scheduleDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
        driversActiveStop: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
        status: typebox_1.Type.Optional(exports.RoutePlanStopStatusType),
    }),
]);
exports.RoutePlanStopTransport = exports.RoutePlanStop;
exports.RoutePlanStopWithFullRoutePlanTransport = typebox_1.Type.Intersect([
    exports.RoutePlanStop,
    typebox_1.Type.Object({
        routePlan: typebox_1.Type.Optional(DailyRoutePlan_1.DailyRoutePlanTransport),
    }),
]);
exports.RoutePlanStopQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    AbstractRouteStop_1.AbstractRouteStopQuery,
    typebox_1.Type.Object({
        templateStopID: typebox_1.Type.String({ format: 'uuid' }),
        routePlanID: typebox_1.Type.String({ format: 'uuid' }),
        hasBreadcrumb: typebox_1.Type.Boolean(),
        hasEvent: typebox_1.Type.Boolean(),
        isOrphaned: typebox_1.Type.Boolean(),
        dateBefore: typebox_1.Type.String({ format: 'date' }),
        dateAfter: typebox_1.Type.String({ format: 'date' }),
    }),
]));
exports.RoutePlanStopCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.RoutePlanStop, [
        'id',
        'haulerID',
        'oneOffPickupRequest',
        'subscriptionEquipment',
        'metadata',
        'templateStop',
        'routePlanID',
        'breadcrumb',
        'eventIDs',
    ]),
    typebox_1.Type.Object({
        subscriptionEquipmentID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    }),
]);
exports.RoutePlanStopCreateNested = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.RoutePlanStop, [
        'id',
        'haulerID',
        'oneOffPickupRequest',
        'metadata',
        'templateStop',
        'routePlanID',
        'breadcrumb',
        'eventIDs',
    ]),
    typebox_1.Type.Object({
        subscriptionEquipmentID: typebox_1.Type.String({ format: 'uuid' }),
    }),
]);
exports.RoutePlanStopUpdate = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.RoutePlanStop, [
    'id',
    'haulerID',
    'oneOffPickupRequest',
    'subscriptionEquipment',
    'metadata',
    'templateStop',
    'routePlanID',
    'breadcrumb',
    'eventIDs',
]));
exports.SubscriptionRoutePlanStopTransport = typebox_1.Type.Object({
    routePlan: typebox_1.Type.Optional(DailyRoutePlan_1.SubscriptionDailyRoutePlanTransport),
    subscriptionEquipment: typebox_1.Type.Optional(SubscriptionEquipment_1.SubscriptionEquipmentEventTransport),
});
//# sourceMappingURL=RoutePlanStop.js.map